import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  "data-test": "tag-list",
  class: "tags"
}
const _hoisted_2 = { "data-test": "tag-text" }
const _hoisted_3 = ["aria-label", "onClick"]
const _hoisted_4 = {
  key: 1,
  "data-test": "tags-empty",
  class: "tags__empty"
}

import { nextTick, onMounted, ref } from 'vue'

import RecordButton from '@/components/customers/record/RecordButton.vue'
import { useToast } from '@/composables/useToast'
import api from '@/store/api'


export default {
  __name: 'ProfileTags',
  props: {
  conversationUserPairId: { type: String, required: true },
  editable: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props

const { showToast } = useToast()

const tags = ref([])
const newTag = ref('')
const adding = ref(false)
const field = ref(null)

const endpoint = () => `conversation_user_pairs/${props.conversationUserPairId}/tags`

const startAdding = async () => {
  adding.value = true
  await nextTick()
  field.value?.focus()
}

const cancelAdding = () => {
  adding.value = false
  newTag.value = ''
}

const addTag = () => {
  const text = newTag.value
  if (!text) return
  newTag.value = ''
  api
    .call('POST', endpoint(), { tag: { tag_text: text } })
    .then(response => {
      tags.value.push(response.data.data.attributes)
      adding.value = false
    })
    .catch(error => {
      newTag.value = text
      showToast(
        error.response?.status === 422
          ? 'This customer already has that tag.'
          : "Couldn't add the tag. Please try again.",
        { type: 'error' }
      )
    })
}

const deleteTag = tag => {
  api.call('DELETE', `${endpoint()}/${tag.id}`).then(() => {
    tags.value = tags.value.filter(item => item.id !== tag.id)
  })
}

onMounted(() => {
  api.call('GET', endpoint()).then(response => {
    tags.value = response.data.data.map(tag => tag.attributes)
  })
})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (tag) => {
        return (_openBlock(), _createElementBlock("span", {
          key: tag.id,
          "data-test": "tag",
          class: "tag-chip"
        }, [
          _cache[1] || (_cache[1] = _createElementVNode("span", {
            class: "tag-chip__dot",
            "aria-hidden": "true"
          }, null, -1)),
          _createElementVNode("span", _hoisted_2, _toDisplayString(tag.tag_text_downcased), 1),
          (__props.editable)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "tag-chip__remove",
                "aria-label": `Remove ${tag.tag_text_downcased}`,
                onClick: $event => (deleteTag(tag))
              }, " × ", 8, _hoisted_3))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      (__props.editable)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            "data-test": "add-tag",
            class: "tag-chip tag-chip--add",
            onClick: startAdding
          }, " + Add tag "))
        : _createCommentVNode("", true),
      (!__props.editable && tags.value.length === 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "No tags yet."))
        : _createCommentVNode("", true)
    ]),
    (adding.value)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          "data-test": "tag-form",
          class: "tag-form",
          onSubmit: _withModifiers(addTag, ["prevent"])
        }, [
          _withDirectives(_createElementVNode("input", {
            ref_key: "field",
            ref: field,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((newTag).value = $event)),
            type: "text",
            class: "tag-form__input",
            placeholder: "Tag name",
            "aria-label": "Tag name",
            onKeydown: _withKeys(cancelAdding, ["esc"])
          }, null, 544), [
            [
              _vModelText,
              newTag.value,
              void 0,
              { trim: true }
            ]
          ]),
          _createVNode(RecordButton, {
            type: "submit",
            variant: "primary"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("Add", -1)
            ]))]),
            _: 1
          }),
          _createVNode(RecordButton, {
            variant: "quiet",
            onClick: cancelAdding
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("Cancel", -1)
            ]))]),
            _: 1
          })
        ], 32))
      : _createCommentVNode("", true)
  ]))
}
}

}